@if (
  !errorMessage &&
  !isSavingResponses &&
  !isLoadingQuestionnaire &&
  !hasCompleted
) {
  @if (explanationText.length > 1) {
    <div class="explanation-text">
      @for (paragraph of explanationText; track paragraph) {
        <p>{{ paragraph }}</p>
      }
    </div>
  }

  <form
    id="questionnaireForm"
    #questionnaireForm="ngForm"
    (ngSubmit)="nextSection()"
  >
    @if (isLoading) {
      <div class="loading-spinner">
        <div class="spinner"></div>
        <p>{{ adjustingQuestionsText }}</p>
      </div>
    } @else {
      <div *ngIf="questionnaire.sections[currentSectionIndex] as section">
        @for (subsection of section.subsections; track subsection) {
          @if (subsection.is_visible) {
            @if (subsection.description.length > 1) {
              <p
                class="subsection-heading"
                [ngClass]="{ 'bold-text': subsection.questions.length > 0 }"
                [innerHTML]="subsection.description"
              ></p>
            }

            @if (subsection.hasOverarchingQuestion) {
              @for (
                question of this.getOverachingQuestionFromSubsection(
                  subsection.questions
                );
                track question.question_id
              ) {
                <div class="form-group">
                  <label class="question-label">{{
                    question.questiion_text
                  }}</label>
                  <div class="radio-group horizontal-options">
                    @for (option of question?.options; track option) {
                      <label>
                        <input
                          type="radio"
                          [(ngModel)]="answers[question.question_id]"
                          [name]="question.question_id"
                          [required]="question.is_required"
                          [value]="getOptionValue(option)"
                          (change)="
                            onOverarchingQuestionChange(
                              question.question_id,
                              option,
                              subsection
                            )
                          "
                        />
                        <span [innerHTML]="option.text"></span>
                      </label>
                    }
                  </div>
                </div>
              }
            }
            @for (
              row of groupQuestionsByRow(subsection.questions);
              track row[0]
            ) {
              <div class="row">
                @for (question of row[1]; track question.question_id) {
                  <div
                    [ngClass]="{
                      'col-md-6': row[1].length > 1,
                      'col-md-12': row[1].length == 1,
                    }"
                  >
                    <!-- Render Question -->
                    <div
                      class="form-group"
                      [style.display]="
                        !question.is_visible && question.is_dependent
                          ? 'none'
                          : 'block'
                      "
                    >
                      <label
                        class="question-label"
                        [style.display]="
                          question.questiion_text.length > 0 ? 'block' : 'none'
                        "
                        >{{ question.questiion_text }}</label
                      >

                      @if (
                        ["single", "multi"].includes(question.question_type) &&
                        this.questionnaireForm.form.get(question.question_id)
                          ?.invalid &&
                        this.questionnaireForm.form.get(question.question_id)
                          ?.touched
                      ) {
                        <div class="error-message ng-margin">
                          {{ getChoiceErrorMessage(question) }}
                        </div>
                      }

                      <!-- Short Input -->
                      <input
                        *ngIf="question.question_type === 'short'"
                        type="text"
                        class="form-control"
                        [ngModel]="answers[question.question_id]"
                        (ngModelChange)="onShortAnswerChange($event, question)"
                        [ngClass]="{
                          'half-width': row[1].length == 1,
                          'invalid-field':
                            this.questionnaireForm.form.get(
                              question.question_id
                            )?.invalid &&
                            this.questionnaireForm.form.get(
                              question.question_id
                            )?.touched,
                        }"
                        [required]="question.is_required"
                        [pattern]="
                          isCurrencyQuestion(question)
                            ? ''
                            : question.validation_rules?.pattern || ''
                        "
                        [attr.inputmode]="isCurrencyQuestion(question) ? 'numeric' : 'text'"
                        [placeholder]="isCurrencyQuestion(question) ? '$0' : ''"
                        name="{{ question.question_id }}"
                      />

                      <!-- Long Input -->
                      <textarea
                        *ngIf="question.question_type === 'long'"
                        class="form-control"
                        [(ngModel)]="answers[question.question_id]"
                        [ngClass]="{
                          'half-width': row[1].length == 1,
                          'invalid-field':
                            this.questionnaireForm.form.get(
                              question.question_id
                            )?.invalid &&
                            this.questionnaireForm.form.get(
                              question.question_id
                            )?.touched,
                        }"
                        [required]="question.is_required"
                        [pattern]="question.validation_rules?.pattern || ''"
                        name="{{ question.question_id }}"
                        rows="3"
                      ></textarea>

                      <!-- Date Input -->
                      <div
                        *ngIf="question.question_type === 'date'"
                        class="input-group date-input"
                        [ngClass]="{
                          'half-width': row[1].length == 1,
                        }"
                      >
                        <input
                          id="dp_{{ question.question_id }}"
                          name="{{ question.question_id }}"
                          class="form-control"
                          ngbDatepicker
                          #dp="ngbDatepicker"
                          [minDate]="minDate"
                          [maxDate]="maxDate"
                          [(ngModel)]="answers[question.question_id]"
                          (ngModelChange)="onDateChange($event, question)"
                          [ngClass]="{
                            'half-width': row[1].length == 1,
                            'invalid-field':
                              this.questionnaireForm.form.get(
                                question.question_id
                              )?.invalid &&
                              this.questionnaireForm.form.get(
                                question.question_id
                              )?.touched,
                          }"
                          [placeholder]="'mm/dd/yyyy'"
                          [required]="question.is_required"
                        />

                        <button
                          type="button"
                          class="btn btn-outline-secondary"
                          (click)="toggleDatePicker(question.question_id)"
                        >
                          <i class="bi-calendar"></i>
                          <!-- Optional icon -->
                        </button>
                      </div>

                      <!-- Address Input -->
                      @if (question.question_type === "address") {
                        <div class="address-container position-relative">
                          <input
                            type="text"
                            class="form-control long-text-input address-input"
                            [ngbTypeahead]="search"
                            [container]="'body'"
                            [(ngModel)]="answers[question.question_id]"
                            name="{{ question.question_id }}"
                            [ngClass]="{
                              'invalid-field':
                                this.questionnaireForm.form.get(
                                  question.question_id
                                )?.invalid &&
                                this.questionnaireForm.form.get(
                                  question.question_id
                                )?.touched,
                            }"
                            [required]="question.is_required"
                            autocomplete="new-password"
                            autocorrect="off"
                            spellcheck="false"
                            aria-autocomplete="none"
                          />

                          @if (isSearchingAddress) {
                            <div class="mini-spinner-container">
                              <div class="mini-spinner"></div>
                            </div>
                          }
                        </div>
                      }

                      <!-- Phone Number Input -->
                      <input
                        *ngIf="question.question_type === 'phone_number'"
                        type="tel"
                        class="form-control phone-input"
                        [(ngModel)]="answers[question.question_id]"
                        (ngModelChange)="
                          formatPhoneNumber($event, question.question_id)
                        "
                        name="{{ question.question_id }}"
                        [ngClass]="{
                          'half-width': row[1].length == 1,
                          'invalid-field':
                            this.questionnaireForm.form.get(
                              question.question_id
                            )?.invalid &&
                            this.questionnaireForm.form.get(
                              question.question_id
                            )?.touched,
                        }"
                        [required]="question.is_required"
                        [pattern]="question.validation_rules?.pattern || ''"
                        autocomplete="new-password"
                        autocorrect="off"
                        spellcheck="false"
                        aria-autocomplete="none"
                        placeholder="(000) 000-0000"
                      />

                      <!-- Single Choice Input -->
                      <div
                        *ngIf="question.question_type === 'single'"
                        class="radio-group"
                        [ngClass]="{
                          'horizontal-options': question.options.length <= 3,
                          'vertical-options': question.options.length > 3,
                        }"
                      >
                        @for (option of question?.options; track option) {
                          <div>
                            <label>
                              <input
                                type="radio"
                                tabindex="1"
                                [style.display]="
                                  !question.is_visible && question.is_dependent
                                    ? 'none'
                                    : 'block'
                                "
                                [(ngModel)]="answers[question.question_id]"
                                [name]="question.question_id"
                                [required]="question.is_required"
                                [value]="getOptionValue(option)"
                              />
                              <span [innerHTML]="option.text"></span>
                            </label>
                          </div>
                        }
                      </div>

                      <!-- Multiselect Input -->
                      <div
                        *ngIf="question.question_type === 'multi'"
                        class="checkbox-group"
                        [ngClass]="{
                          'horizontal-options': question.options.length <= 3,
                          'vertical-options': question.options.length > 3,
                        }"
                      >
                        @for (option of question?.options; track option) {
                          <div [style.display]="option.isHidden ? 'none' : 'block'">

                            <label>
                              <input
                                [id]="question.question_id"
                                type="checkbox"
                                aria-hidden="false"
                                tabindex="1"
                                [style.display]="
                                  !question.is_visible && question.is_dependent
                                    ? 'none'
                                    : 'block'
                                "
                                [name]="question.question_id"
                                [value]="getOptionValue(option)"
                                [(ngModel)]="
                                  selectedOptions[question.question_id][
                                    getOptionValue(option)
                                  ]
                                "
                                (ngModelChange)="
                                  onMultiCheckboxChange(
                                    $event,
                                    question.question_id,
                                    getOptionValue(option)
                                  )
                                "
                              />
                             
                                {{ option.text }}
                              
                            </label>
                          </div>
                        }
                      </div>

                      @if (
                        ["short", "long", "date", "phone_number"].includes(
                          question.question_type
                        ) &&
                        this.questionnaireForm.form.get(question.question_id)
                          ?.invalid &&
                        this.questionnaireForm.form.get(question.question_id)
                          ?.touched
                      ) {
                        <div class="error-message">
                          {{ getInputErrorMessage(question) }}
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          }
        }
      </div>

      <!-- Navigation Buttons -->
      <button
        class="btn btn-primary mt-3 submit-btn"
        type="submit"
        *ngIf="currentSectionIndex < questionnaire.sections.length - 1"
      >
        {{ nextSectionButtonText }}
      </button>

      <!-- Submit Button -->
      <button
        type="submit"
        class="btn btn-primary mt-3 submit-btn"
        *ngIf="currentSectionIndex === questionnaire.sections.length - 1"
      >
        {{ submitButtonText }}
      </button>
    }
  </form>
}
